import { OnInit, Component, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { of } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AlertService } from '@core/services/alert.service';
import { LoadingService } from '@core/services/loading.service';
import { SessionService } from '@core/services/session.service';
import { Role } from '@shared/models/role';

import { UnSubscribable } from '../../../../core';
import { UserService } from '../../../../../eightcap-core';
import { UserReset } from '../../models';



@Component({
    selector: 'app-reset-user-info',
    templateUrl: './reset-user-information.html',
    styleUrls: ['./reset-user-information.scss']
})
export class ResetUserInformation extends UnSubscribable implements OnInit {
    @Input()
    data: any;
    @Output()
    componentClose = new EventEmitter();

    form: FormGroup;

    isAdminAllRole: boolean = false;

    readonly passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z0-9$@!%*#?&+=-_{}[\];':"<>,./~`()]{8,}$/;

    constructor(
        private readonly fb: FormBuilder,
        private readonly alertService: AlertService,
        private readonly loadingService: LoadingService,
        private readonly userService: UserService,
        private readonly translateService: TranslateService,
        private readonly sessionService: SessionService
        
    ) {
        super();
    }

    ngOnInit(): void {
        const userRole = this.sessionService.userRole;
        this.isAdminAllRole = userRole === Role.ADMIN_ALL;
        this.buildForm();
    }

    private buildForm(): void {
        const formData: Record<string, any> = {
            email_override: [this.data.email, [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
        }
        if (this.isAdminAllRole) {
            formData['is_send_email'] = [true]
        }
        this.form = this.fb.group(formData);
    }

    onSave(): void {
        const userReset: UserReset = {
            email_override: this.form.get('email_override').value.trim(),
            password: this.form.get('password').value,
            is_send_email: this.form.get('is_send_email')?.value
        }
        const confirmMessage = userReset.is_send_email ? 'user.message.change_password_and_send_email': 'user.message.change_password';
        this.alertService.alertConfirmation('save', this.translateService.instant(confirmMessage))
            .pipe(
                mergeMap((alertResult) => {
                    if(alertResult.isConfirmed) {
                        this.loadingService.show();
                        return this.userService.resetForce(this.data.id, userReset);
                    } else {
                        return of(null);
                    }
                }),
                takeUntil(this.unsubscribeAll)
            ).subscribe({
                next: (result) => {
                    this.loadingService.hide();
                    if (!result) {
                        return;
                    }
                    let successMessage = userReset.is_send_email ? 'user.message.change_password_and_send_email_success': 'user.message.change_password_success';
                    this.alertService.notifySuccess(this.translateService.instant(successMessage, {email: userReset.email_override}));
                    this.componentClose.emit();
                },
                error: (error) => {
                    const errorObj = this.alertService.getError(error);
                    this.alertService.notifyError(errorObj.message);
                    this.loadingService.hide();
                }
            });
    }
}
